import React from "react";
import { picture, sideScroll } from "./look";

function FallbackCard() {
  return (
    <div style={{ position: "relative", margin: "0 16px", borderRadius: 16, background: "#1F2430", padding: "20px 18px", overflow: "hidden" }}>
      <div style={{ position: "absolute", right: -30, top: -30, width: 120, height: 120, borderRadius: 60, background: "#FB310D", opacity: 0.85 }} />
      <div style={{ position: "relative", fontSize: 22, fontWeight: 700, color: "#fff" }}>Foodoor Surplus</div>
      <div style={{ position: "relative", fontSize: 13, color: "#E7E9EE", marginTop: 6, maxWidth: "75%" }}>
        Fresh food the restaurant wants to clear, at a cut
      </div>
    </div>
  );
}

export default function SaleHero({ block }) {
  return (
    <div style={{ marginTop: 14 }}>
      {!block.rows.length ? (
        <FallbackCard />
      ) : (
        <div style={{ ...sideScroll, gap: 10, padding: "0 16px", scrollSnapType: "x mandatory" }}>
          {block.rows.map((banner) => (
            <img key={banner.id} src={picture(banner.image)} alt=""
              style={{ flex: "0 0 100%", height: 150, borderRadius: 16, objectFit: "cover", scrollSnapAlign: "center" }} />
          ))}
        </div>
      )}
    </div>
  );
}
